export const fieldsTranslationsRo = {
  'fields-parameters.navbar.services.title': 'Servicii',
  'fields-parameters.title': 'Parametrii parcelelor',
  'fields-parameters.services.table.title': 'Parcele',
  'service.field_parameters.column.farmer_name.label': 'Exploatație',
  'service.field_parameters.column.field_number.label': 'Număr de parcele',
  'service.field_parameters.column.total_area.label': 'Suprafață totală (ha)',
  'service.field_parameters.detail_panel.column.field_name.label': 'Numele parcelei',
  'service.field_parameters.detail_panel.column.area.label': 'Suprafață (ha)',
  'service.field_parameters.detail_panel.column.service.label': 'Serviciu',
  'service.field_parameters.detail_panel.column.crop.label': 'Cultură',
  'service.field_parameters.detail_panel.column.subscription.label': 'Abonament',
  'service.field_parameters.detail_panel.column.subscription.active.label': 'Activ',
  'service.field_parameters.detail_panel.column.subscription.no_subscription.label': 'Fără abonament',
  'service.field_parameters.detail_panel.column.service.button.parameter.label': 'Parametri',
  'irrigation_field_service_parameters.button.undo.label': 'Anulați modificările',
  'irrigation_field_service_parameters.button.save.label': 'Salvați modificările',
  'irrigation_field_service_parameters.multiple_edition.button.apply.label': 'Aplicați',
  'irrigation_field_service_parameters.multiple_edition.button.clear.label': 'Ștergeți',
  'irrigation_field_service_parameters.multiple_edition.title.label': 'Editarea mai multor parcele',
  'irrigation_field_service_parameters.multiple_edition.info.setp1':
    '1- Completați câmpurile pe care doriți să le aplicați mai multor parcele',
  'irrigation_field_service_parameters.multiple_edition.info.setp2':
    '2- Selectați parcelele pentru care doriți să aplicați parametrii',
  'irrigation_field_service_parameters.multiple_edition.info.setp3':
    '3- Confirmați făcând clic pe butonul aplicați (Atenție: pot apărea erori)',
  'irrigation_field_service_parameters.multiple_edition.info.setp4': '4- Salvați pentru a aplica actualizarea',
  'irrigation_field_service_parameters.table.Column.farmer_name.label': 'Exploatație',
  'irrigation_field_service_parameters.table.Column.field_number.label': 'Număr de parcele',
  'irrigation_field_service_parameters.table.Column.total_area.label': 'Suprafață totală (ha)',
  'irrigation_field_service_parameters.table.detail_panel.column.field.label': 'Parcelă',
  'irrigation_field_service_parameters.table.detail_panel.column.soil.label': 'Sol',
  'irrigation_field_service_parameters.table.detail_panel.column.weather_station.label': 'Stație meteo',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_management.label': 'Gestionarea irigației',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_threshold.label': 'Pragul de irigare',
  'irrigation_field_service_parameters.table.detail_panel.column.assolment.label': 'Asolament',
  'fields-parameters.dialog.error.title': 'Eroare la salvare',
  'fields-parameters.dialog.error.legend': 'Unele dintre modificările dvs. au întâmpinat erori și nu au fost salvate.',
  'fields-parameters.dialog.error.contact':
    'Dacă problema persistă, vă rugăm să trimiteți aceste erori serviciului nostru de asistență la adresa csm@pixagri.fr',
};
